import React, { useMemo, useState, useEffect } from 'react';

/**
 * Siyahıdan seçim + "Digər" halında əl ilə yazma.
 *
 * Dəyər həmişə MƏTN kimi saxlanılır — yəni valideyn siyahıdan seçsə də,
 * əl ilə yazsa da, forma eyni sahəni göndərir. Beləliklə baza tərəfdə
 * əlavə sütun və ya xüsusi emal lazım gəlmir.
 *
 * value siyahıda yoxdursa və boş deyilsə, komponent özü "Digər" rejiminə
 * keçir — mövcud qeydi redaktə edəndə yazılan mətn itmir.
 */
export default function SelectOrType({
  value = '',
  onChange,
  options = [],
  placeholder = 'Seçin',
  otherLabel = 'Digər',
  typePlaceholder = 'Əl ilə yazın',
  className = '',
  required = false,
  disabled = false,
  name,
}) {
  const inList = useMemo(
    () => !!value && options.includes(value),
    [value, options]
  );
  const [manual, setManual] = useState(() => !!value && !inList);

  // Kənardan gələn dəyər siyahıdakı bir seçimə dəyişsə, rejimi uyğunlaşdır
  useEffect(() => {
    if (value && options.includes(value)) setManual(false);
  }, [value, options]);

  const selectValue = manual ? '__other__' : (inList ? value : '');

  const handleSelect = (e) => {
    const v = e.target.value;
    if (v === '__other__') {
      setManual(true);
      onChange('');              // yazmaq üçün sahə boşalır
    } else {
      setManual(false);
      onChange(v);
    }
  };

  return (
    <div className="sot-wrap">
      <select
        className={className}
        value={selectValue}
        onChange={handleSelect}
        required={required && !manual}
        disabled={disabled}
        name={name ? name + '_select' : undefined}
      >
        <option value="">{placeholder}</option>
        {options.map(o => <option key={o} value={o}>{o}</option>)}
        <option value="__other__">{otherLabel}…</option>
      </select>

      {manual && (
        <input
          type="text"
          className={className}
          style={{ marginTop: 8 }}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={typePlaceholder}
          required={required}
          disabled={disabled}
          autoFocus
        />
      )}
    </div>
  );
}
